import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { INotificationEvent } from "shared/cubiq-services";

import { BfxPopupNotificatonSettingsService } from "../../bfx-common/services/bfx-popup-notifications-settings.service";
import { BfxPopupEventSetting } from "../../bfx-user-settings/model/bfx-popup-event-setting";

import * as CubiqServices from "shared/cubiq-services";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { NotificationService } from "shared/cubiq-services/lookup/notification/impl/NotificationService";
import { BFXNotificationType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationType";

/**
 * Service that manages the mapping between an NotifcationType and the user setting that governs the
 * popup notification sofr that event type. It will return the correct setting based on any order type that
 * is available in the payoad of the event and supports mapping of Limit types to algo types
 */
@Injectable()
export class BfxPopupSettingProviderService {
  private notifMap: Map<BFXNotificationType, BfxPopupEventSetting> = new Map();

  constructor(
    private popupNotificationSettingsService: BfxPopupNotificatonSettingsService,
    private notifService: NotificationService,
  ) {
    this.initializeSettingsAndSubscriptions();
  }

  // load the popup notification settings, if they are not saved to the profile,
  // we need to load a default per user, that last part still needs to be completed
  private initializeSettingsAndSubscriptions(): void {
    this.notifMap.clear();
    this.popupNotificationSettingsService.getPopupSettingsStream().subscribe((settingsUpdate) => {
      this.updateSettings(settingsUpdate);
      this.notifService.setNotificationTypes(this.notifMap.keys());
    });
    this.popupNotificationSettingsService
      .getPopupBmarkSettingsStream()
      .subscribe((settingsUpdate) => {
        this.updateSettings(settingsUpdate);
        this.notifService.setNotificationTypes(this.notifMap.keys());
      });
    // Promise.all([
    //   this.popupNotificationSettingsService.getPopupNotificationsSettings(),
    //   this.popupNotificationSettingsService.getBmarkPopupNotificationsSettings(),
    // ]).then(([defaultNotificationSettings, bmarkPopupNotificationSettings]) => {
    //   this.updateSettings(defaultNotificationSettings);
    //   this.updateSettings(bmarkPopupNotificationSettings);
    //   this.notifService.setNotificationTypes(this.notifMap.keys());
    // });
  }

  /**
   * Apply new setting to local state
   * @param settings
   */
  private updateSettings(settings: Array<BfxPopupEventSetting>) {
    settings.forEach((event) => {
      if (event.enabled) {
        this.notifMap.set(event.type, event);
      } else {
        this.notifMap.delete(event.type);
      }
    });
  }

  /**
   * Get the user setting that covers the specified notification event. If the notification payload
   * is an algo, then any configured algo-specific setting is returned
   * @param event
   * @returns
   */
  public getNotificationSetting(event: INotificationEvent): BfxPopupEventSetting {
    let requestType;
    if (event.orderNotifData) {
      // Order events
      requestType = event.orderNotifData.requestedOrderType;
    } else if (event.tradeNotifData) {
      // For trade events
      requestType = event.tradeNotifData.requestedOrderType;
    }
    const isAlgo: Boolean = requestType == CubiqTS.RequestOrderType.ALGO;
    const isBMAlgo: Boolean = requestType == CubiqTS.RequestOrderType.BMALGO;

    let retSetting: BfxPopupEventSetting = null;
    if (isAlgo || isBMAlgo) {
      // We need to use the Algo-specific setting rather than the general setting
      let algoType: BFXNotificationType;
      switch (event.notifType) {
        case CubiqServices.BFXNotificationType.ACTIVATED:
          algoType = CubiqServices.BFXNotificationType.ALGO_ACTIVATED;
          break;
        case CubiqServices.BFXNotificationType.ACTIVATING:
          algoType = CubiqServices.BFXNotificationType.ALGO_ACTIVATING;
          break;
        case CubiqServices.BFXNotificationType.CANCELLED:
          algoType = CubiqServices.BFXNotificationType.ALGO_CANCELLED;
          break;
        case CubiqServices.BFXNotificationType.DEAL_FAILURE:
          algoType = CubiqServices.BFXNotificationType.ALGO_DEAL_FAILURE;
          break;
        case CubiqServices.BFXNotificationType.LIMITALGO_ORDER_ENTERED:
          algoType = CubiqServices.BFXNotificationType.ALGO_LIMITALGO_ORDER_ENTERED;
          break;
        case CubiqServices.BFXNotificationType.EXPIRED:
          algoType = CubiqServices.BFXNotificationType.ALGO_EXPIRED;
          break;
        case CubiqServices.BFXNotificationType.EXPIRING:
          algoType = CubiqServices.BFXNotificationType.ALGO_EXPIRING;
          break;
        case CubiqServices.BFXNotificationType.FILLED:
          algoType = CubiqServices.BFXNotificationType.ALGO_FILLED;
          break;
        case CubiqServices.BFXNotificationType.PART_FILLED:
          algoType = CubiqServices.BFXNotificationType.ALGO_PART_FILLED;
          break;
        case CubiqServices.BFXNotificationType.MODIFIED:
          algoType = CubiqServices.BFXNotificationType.ALGO_MODIFIED;
          break;
        case CubiqServices.BFXNotificationType.ACCEPTANCE_NEEDED:
          algoType = CubiqServices.BFXNotificationType.ALGO_ACCEPTANCE_NEEDED;
          break;
        case CubiqServices.BFXNotificationType.UNSOLICITED_CANCEL:
          algoType = CubiqServices.BFXNotificationType.ALGO_UNSOLICITED_CANCEL;
          break;
        case CubiqServices.BFXNotificationType.UNSOLICITED_PAUSE_RESUME:
          algoType = CubiqServices.BFXNotificationType.ALGO_UNSOLICITED_PAUSE_RESUME;
          break;
      }
      if (algoType) {
        retSetting = this.notifMap.get(algoType);
      }
    }

    if (!retSetting) {
      // If we can't find Algo setting (either it hasn't been migrated yet or doesn't exist)
      // fall back to the standard limit setting
      retSetting = this.notifMap.get(event.notifType);
    }
    return retSetting;
  }
}
